import { fetchData, APIMethod, ACCESS_DOMAINS } from "@client";

export async function getProjectsLabelsQuery(projectId) {
  return await fetchData(`api/get-labels/${projectId}`, APIMethod.GET, {
    baseURL: ACCESS_DOMAINS.btApi,
  });
}